<template>
  <div class="other-setting">
    <div class="search-engine">
      <div class="search-engine-title">{{$t('newProjectV2.defaultSearchEngine')}}</div>
      <div class="search-engine-list">
        <!-- <div>
          <el-radio v-model="engineNum" @change="radioChange" :label="1">
            <i class="icon baidu"></i>
          </el-radio>
        </div>
        <div>
          <el-radio v-model="engineNum" @change="radioChange" :label="2">
            <i class="icon google"></i>
          </el-radio>
        </div>
        <div>
          <el-radio v-model="engineNum" @change="radioChange" :label="3">
            <i class="icon souguo"></i>
          </el-radio>
        </div>
        <div>
          <el-radio v-model="engineNum" @change="radioChange" :label="4">
            <i class="icon bing"></i>
          </el-radio>
        </div> -->
        <div v-for="engine in SEARCH_ENGINE" :key="engine.icon">
          <el-radio v-model="engineNum" @change="radioChange" :label="engine.value">
            <i class="icon" :class="engine.icon"></i>
          </el-radio>
        </div>
      </div>
    </div>
    <div class="document-setting">
      <div class="doc-title">{{$t('newProjectV2.docSetting')}}</div>
      <div class="docList">
        <div class="item" v-for="(item, index) in docSetList" :key="index">
          <div class="docIcon" :class="`icon-${item.type}`"></div>
          <div class="docBottom">
            <ul :style="{ 'width': $i18n.locale === 'zh' ? '' : '225px' }">
              <li>
                <el-checkbox v-model="item.isEnable" @change="handleCheckAll(item.type)">{{$t('newProjectV2.selectAll')}}</el-checkbox>
              </li>
              <li v-for="(item, index) in item.list" :key="index">
                <el-checkbox v-model="item.isEnable">{{$i18n.locale === 'zh' ? item.name : item.nameEn}}</el-checkbox>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OtherSetting',
  props: {
    searchEngine: {
      type: Number,
      default () {
        return 1;
      }
    },
    docSetList: {
      type: Array,
      default () {
        return []
      }
    },
  },
  data () {
    return {
      engineNum: this.searchEngine,
      SEARCH_ENGINE: SEARCH_ENGINE,
    };
  },
  methods: {
    radioChange () {
      this.$emit('searchEngineChange', this.engineNum);
    },
    handleCheckAll (key) {
      this.docSetList.forEach(item => {
        if (item.type === key) {
          item.list.forEach(i => {
            i.isEnable = item.isEnable;
          });
        }
      });
    },
  },
  watch: {
    docSetList: {
      handler (newVal) {
        newVal.forEach(item => {
          item.isEnable = item.list.every(item => item.isEnable === true);
        });
      },
      deep: true,
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>